import { useState, useEffect, useCallback } from "react";
import {
  collection, onSnapshot, addDoc, deleteDoc,
  doc, serverTimestamp, query, orderBy, updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const COL = "team_members";

export function useTeamMembers() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setLoading(false), 5000);
    const q = query(collection(db, COL), orderBy("createdAt", "asc"));
    const unsub = onSnapshot(q,
      (snap) => {
        clearTimeout(timeout);
        setMembers(snap.docs.map(d => ({ ...d.data(), id: d.id })));
        setLoading(false);
      },
      () => { clearTimeout(timeout); setLoading(false); }
    );
    return () => { clearTimeout(timeout); unsub(); };
  }, []);

  const addMember = useCallback(async ({ name, email, role }) => {
    await addDoc(collection(db, COL), { name, email, role: role || "Sales Team", createdAt: serverTimestamp() });
  }, []);

  const removeMember = useCallback(async (id) => {
    await deleteDoc(doc(db, COL, id));
  }, []);

  const updateMember = useCallback(async (id, fields) => {
    await updateDoc(doc(db, COL, id), fields);
  }, []);

  return { members, loading, addMember, removeMember, updateMember };
}
